import React from 'react'

import { InvoiceStatus } from '../../types'
import './statusBadge.scss'

export const STATUS_LABELS: Record<InvoiceStatus, string> = {
  [InvoiceStatus.DRAFT]: 'Draft',
  [InvoiceStatus.OPEN]: 'Open',
  [InvoiceStatus.OVERDUE]: 'Overdue',
  [InvoiceStatus.PAID]: 'Paid',
}

const STATUS_VARIANT_CLASS: Record<InvoiceStatus, string> = {
  [InvoiceStatus.DRAFT]: 'bg-light text-body-secondary',
  [InvoiceStatus.PAID]: 'bg-success-subtle text-success-emphasis',
  [InvoiceStatus.OVERDUE]: 'bg-warning-subtle text-secondary-emphasis',
  [InvoiceStatus.OPEN]: 'bg-secondary-subtle text-secondary-emphasis',
}

type Props = {
  status: InvoiceStatus
  size?: 'sm' | 'md'
}

const StatusBadge: React.FC<Props> = ({ status, size = 'sm' }) => {
  const label = STATUS_LABELS[status] ?? STATUS_LABELS[InvoiceStatus.DRAFT]
  const variantClass = STATUS_VARIANT_CLASS[status] ?? STATUS_VARIANT_CLASS[InvoiceStatus.DRAFT]

  return (
    <span
      className={`invoice-status-badge invoice-status-badge--${size} badge rounded-pill ${variantClass}`}
    >
      {label}
    </span>
  )
}

export default StatusBadge
